//====================================================
//  Function: Rate
//====================================================
function fn_components_rate(){
	if ($( '.js-rate' ).length) {
		$( '.js-rate .js-rate-list-item' ).hover(function(){
			var inst = $(this);
			var list = inst.closest( '.js-rate-list' );
			var rateBlock = inst.closest( '.js-rate' );
			var percent = inst.data( 'percent' );
			var id = inst.index() + 1;

			for(i = 0; i <= 5; i++){
				if (i < id){
					list.find( '.js-rate-list-item' ).eq(i).addClass( class_active );
				} else {
					list.find( '.js-rate-list-item' ).eq(i).removeClass( class_active );
				}
			}

			rateBlock.find( '.js-rate-input' ).val(percent);
			
			rateBlock.find( '.js-rate-percent' ).text(percent);
			
			// if (percent > 0){
			// 	rateBlock.addClass( 'is-rated' );
			// } else {
			// 	rateBlock.removeClass( 'is-rated' );
			// }

			callbackSetRate(id, percent);
			return false;
		});

		// Callback for set rate
		function callbackSetRate(id, percent){
			console.log('HviezdiÄŤek: ' + id);
			console.log('Percenta: ' + percent);
			console.log('\n\n');
		}
	}
	
}
